import React from "react";
import MetricCard from "../MetricCard";
import { formatNumberWithCommas } from "./metricsUtils";

interface GrossProfitCardProps {
  grossProfit: number;
  timeFrame?: string;
  noData?: boolean;
}

const GrossProfitCard: React.FC<GrossProfitCardProps> = ({
  grossProfit,
  timeFrame = "Past 30 days",
  noData = false,
}) => {
  return (
    <MetricCard
      title="Revenue"
      value={`$${formatNumberWithCommas(grossProfit)}`}
      tooltip={`Revenue before subtracting budget spent (${timeFrame})`}
      min={0}
      max={6000}
      current={grossProfit}
      hideMinLabel={true}
      noData={noData}
    />
  );
};

export default GrossProfitCard;
